(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('inlineList', ["path", "recreateDropdownWorkaround", "modals", "defaultListConverter", "$timeout", function (path, recreateDropdownWorkaround, modals, defaultListConverter, $timeout) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('common').directive('inline-list').template(),
            scope: { model: '=inlineList' },
            link: function ($scope, element, attrs) {
                $scope.expanded = function () {
                    var expanded = $scope.model.expanded || 1;
                    if ($scope.model.collapseRest) {
                        return expanded;
                    }
                    return $scope.model.data.length > expanded ? 0 : expanded;
                };
                $scope.initialData = _($scope.model.data).first(10);
                $scope.elementTooltip = function (element) {
                    return $scope.model.elementAsTooltip && !/^#\{/.test(element) && element;
                };
                var options = {
                    'options': {
                        'checkboxes': false,
                        'singleSelection': false,
                        'autoUpdate': 60000,
                        'forceServerProcessing': false
                    },
                    columns: [{
                            id: 'value',
                            text: 'Value',
                            converter: $scope.model.converter,
                            converterArgs: $scope.model.converterArgs
                        }]
                };
                var tableOptions = {
                    pagesAround: 2,
                    pageSize: 20,
                    pagination: {
                        page: 1,
                        ordering: {},
                        filter: ''
                    },
                    disableTop: true
                };
                $scope.openMore = function () {
                    modals.table({
                        tableOptions: tableOptions,
                        options: options,
                        'class': 'avanan-table',
                        retrieve: function (args) {
                            var response = $scope.model.data;
                            if (args.filter) {
                                response = _(response).filter(function (d) {
                                    return d && d.indexOf(args.filter) != -1;
                                });
                            }
                            return defaultListConverter({
                                data: {
                                    total_rows: response.length,
                                    page: Math.floor(args.offset / args.limit) + 1,
                                    rows: _(response).chain().rest(args.offset).first(args.limit).map(function (value) {
                                        return { value: value };
                                    }).value()
                                }
                            }, options);
                        },
                        cancelText: 'Close',
                        okText: null,
                        title: 'List items',
                        closeOnNavigate: true
                    }, 'lg');
                };
                recreateDropdownWorkaround($scope, $(element).find('> .dropdown').get(0));
                var menu = null;
                $scope.toggled = function (open) {
                    if (!$scope.model.appendTo) {
                        return;
                    }
                    var appendToObj = element.closest($scope.model.appendTo);
                    if (!appendToObj.length) {
                        return;
                    }
                    var appendChildren = appendToObj.children();
                    if (!appendChildren.length) {
                        return;
                    }
                    $timeout(function () {
                        if (open) {
                            menu = element.find('.dropdown-menu');
                            if (!menu.length) {
                                return;
                            }
                            var parent = menu[0].offsetParent;
                            if (!parent) {
                                return;
                            }
                            var menuLeft = menu[0].offsetLeft;
                            var menuTop = menu[0].offsetTop;
                            var menuHeight = menu[0].offsetHeight;
                            var menuWidth = menu[0].offsetWidth;
                            menu.appendTo(appendToObj);
                            while (parent && parent !== appendChildren[0].offsetParent) {
                                menuLeft += parent.offsetLeft;
                                menuTop += parent.offsetTop;
                                parent = parent.offsetParent;
                            }
                            menu.css({
                                top: menuTop + 'px',
                                left: menuLeft + 'px',
                                height: menuHeight + 'px',
                                width: menuWidth + 'px'
                            });
                            menu.addClass('absolute-dropdown-menu-opened');
                        } else {
                            if (menu) {
                                if (document.body.contains(menu[0])) {
                                    menu.removeClass('absolute-dropdown-menu-opened');
                                    menu.css({
                                        top: '',
                                        left: '',
                                        height: '',
                                        width: ''
                                    });
                                    menu.appendTo(element.find('> .dropdown'));
                                }
                                menu = null;
                            }
                        }
                    });
                };
                if ($scope.model.showAll && $scope.model.name) {
                    $scope.$on('show-all-' + $scope.model.name, function () {
                        $scope.openMore();
                    });
                }
            }
        };
    }]);
}());